<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()" (keydown)="onClose()" (keyup)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-heading">{{ heading }}</h2>
      </div>
      <div class="modal-body">
        <p class="modal-description">{{ description }}</p>
      </div>
      <div class="modal-footer">
        <button class="modal-button primary" *ngIf="primaryButtonText" (click)="onPrimaryClick()">
          {{ primaryButtonText }}
        </button>
        <button class="modal-button secondary" *ngIf="secondaryButtonText" (click)="onSecondaryClick()">
          {{ secondaryButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>